module.exports = __webpack_public_path__ + "img/placeholder_all.87779065.svg";